import { BaseEntity } from '../base-entity';

/// <code-import> Place custom imports between <code-import> tags
import { EntityName } from '@mri-platform/dsg/core';
/// </code-import>

export interface OrganisationWorkspaceInfo {
  id: string;
  backgroundColor: string;
  isDeleted: boolean;
  longLabel?: string;
  shortLabel: string;
  templateWorkspaceId: string;
  tenantKey: string;
  workspaceQualifier: string;
}

/// <module-code> Place module level code between <module-code> tags
export enum OrganisationWorkspaceDeploymentStatus {
  Pending = 'Pending',
  InProgress = 'InProgress',
  Completed = 'Completed',
  Failed = 'Failed',
  Cancelled = 'Cancelled',
  RequiresRefresh = 'RequiresRefresh',
  Aborted = 'Aborted',
  RolledBack = 'RolledBack',
  RefreshFailed = 'RefreshFailed',
  RefreshAborted = 'RefreshAborted'
}

export type ActiveDeploymentStatus =
  | OrganisationWorkspaceDeploymentStatus.Pending
  | OrganisationWorkspaceDeploymentStatus.InProgress
  | OrganisationWorkspaceDeploymentStatus.RequiresRefresh;

export enum WorkspaceType {
  Primary = 'Primary'
}

export type WorkspaceIdentifiers = Pick<
  OrganisationWorkspaceInfo,
  'workspaceQualifier' | 'longLabel' | 'shortLabel' | 'workspaceQualifiedLongLabel' | 'workspaceQualifiedShortLabel'
>;

export interface OrganisationWorkspaceInfo {
  activeDeploymentStatus: ActiveDeploymentStatus | null;
}

const typeFuncs = BaseEntity.makeStaticTypeFunctions<OrganisationWorkspaceInfo>(EntityName.OrganisationWorkspaceInfo);
/// </module-code>

export class OrganisationWorkspaceInfo extends BaseEntity {
  /// <code> Place custom code between <code> tags
  static propName = typeFuncs.propName;

  get workspaceQualifiedLongLabel() {
    return `${this.longLabel}${this.workspaceQualifier === WorkspaceType.Primary ? '' : ` (${this.workspaceQualifier})`}`;
  }

  get workspaceQualifiedShortLabel() {
    return `${this.shortLabel}${this.workspaceQualifier === WorkspaceType.Primary ? '' : ` (${this.workspaceQualifier})`}`;
  }
  /// </code>
  // Generated code. Do not place code below this line.
}
